import React from 'react';
// import { useHistory } from 'react-router-dom';
import Navbar from '../../components/Navbar';
// import { styled } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { Helmet } from 'react-helmet';

import { METADATA } from '../../constants';
import UnitsContentTable from '../../components/UnitsContentTable';

// const StyledTabs = styled((props) => (
//   <Tabs
//     {...props}
//     TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
//   />
// ))({
//   "& .MuiTabs-indicator": {
//     display: "flex",
//     justifyContent: "center",
//     backgroundColor: "transparent"
//   },
//   "& .MuiTabs-indicatorSpan": {
//     maxWidth: 40,
//     width: "100%",
//     backgroundColor: "#635ee7"
//   }
// });

// const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
//   ({ theme }) => ({
//     textTransform: "none",
//     fontWeight: theme.typography.fontWeightRegular,
//     fontSize: theme.typography.pxToRem(15),
//     marginRight: theme.spacing(1),
//     color: "rgba(255, 255, 255, 0.7)",
//     "&.Mui-selected": {
//       color: "#fff"
//     },
//     "&.Mui-focusVisible": {
//       backgroundColor: "rgba(100, 95, 228, 0.32)"
//     }
//   })
// );

export default function TaggedContent() {
  // const history = useHistory();
  // const [value, setValue] = React.useState(0);

  // const handleChange = (event, newValue) => {
  //   setValue(newValue);
  // };

  return (
    <>
      <Helmet>
        <meta name="description" content={METADATA.UNITS.description} />
        <title>{METADATA.UNITS.title}</title>
      </Helmet>
      <Navbar />
      <Grid container className="dashboard-content container" justify="center">
        <Grid
          className="dashboard-content main-menu"
          justify="center"
          xs={12}
          md={12}
          lg={12}>
            <UnitsContentTable />
        </Grid>
      </Grid>
    </>
  )
}